import React from 'react';
import slugify from 'slugify';
import analytics from 'app/utils/analytics';
import mixpanel, { trackedEvents } from 'app/utils/mixpanel';
import capitalize from 'lodash/capitalize';
import PlanInfoColumnBase from './PlanInfoColumnBase';
import PlanInfoRowBase from './PlanInfoRowBase';
import PlanInfoCard from './PlanInfoCard';

interface OwnProps {
  plan: {
    information: {
      key: string;
      value: string;
    };
    name: string;
    planUrl: string;
  };
  alignment?: 'vertical' | 'horizontal';
  showTitle?: boolean;
  productLink?: string;
  productUrl?: string;
  withCard?: boolean;
  productId?: string;
}

const PlanInfo = (props: OwnProps) => {
  const {
    plan,
    alignment = 'vertical',
    showTitle = true,
    // Internal Link for product
    productLink,
    // exnternal Url for product
    productUrl,
    withCard,
    productId,
  } = props;

  // planDetailsUrl is the internal link for plan
  const { information, name, planUrl } = plan;
  const informationKey = information ? Object.keys(information) : [];
  let ctaTitle;
  let planPrice;

  const informations = informationKey
    .filter(key => {
      if (key === 'price') {
        /* eslint-disable @typescript-eslint/dot-notation */
        ctaTitle = `S$ ${information['price']}`;
        planPrice = information['price'];
      }
      return key !== 'price';
    })
    .map(key => {
      return {
        key,
        value: information[key],
      };
    });

  let PlanInfoInternal;

  if (alignment === 'vertical') {
    PlanInfoInternal = (
      <PlanInfoColumnBase
        title={showTitle ? name : ''}
        informations={informations}
      />
    );
  }

  if (alignment === 'horizontal') {
    PlanInfoInternal = (
      <PlanInfoRowBase
        title={showTitle ? name : ''}
        informations={informations}
      />
    );
  }

  if (withCard) {
    const applyNowUrl = planUrl || productLink;
    const analyticUrl = `${productUrl}/${slugify(name, { lower: true })}`;
    return (
      <PlanInfoCard
        applyNowUrl={applyNowUrl}
        onApplyNowClick={() => {
          const category = productUrl.split('/')[1].replace(/-/g, ' ');
          const product = productUrl.split('/')[2].replace(/-/g, ' ');
          mixpanel.track(trackedEvents.Outbound, {
            'Category Name': capitalize(category),
            'Product Name': capitalize(product),
            'Plan Name': capitalize(plan.name),
          });
          analytics.trackOutbound({
            url: analyticUrl,
            from: 'Product - Plan Carousel',
          });

          // track only car insurance for now
          analytics.trackPlanApplyButton({
            id: productId,
            productName: plan.name,
            productCategory: 'car-insurance',
            productPrice: planPrice,
          });
        }}
        ctaTitle={ctaTitle}
      >
        {PlanInfoInternal}
      </PlanInfoCard>
    );
  }
  return PlanInfoInternal;
};

export default PlanInfo;
